<div class="headline">
  <div class="designs-count">
    {{ 'i18n.toolbox.layout.template.count' | translate:templateCount }}
  </div>
  <div class="mode-switch">
    <mat-icon svgIcon="view-grid"
              [ngClass]="{'active': viewMode === 'grid'}"
              (click)="switchView('grid')"></mat-icon>
    <mat-icon svgIcon="view-single"
              [ngClass]="{'active': viewMode === 'single'}"
              (click)="switchView('single')"></mat-icon>
  </div>
</div>

@if (templateGroups.length > 0) {
  <div class="template-group-switch"
       (pointerdown)="groupSwitchPointerDown($event)"
       (pointermove)="groupSwitchPointerMove($event)"
       (wheel)="groupSwitchWheel($event)">
    @for (templateGroup of templateGroups; track templateGroup) {
      <span class="template-group-switch-item"
            [ngClass]="{'active': templateGroup.id === selectedTemplateGroupId}"
            (click)="templateGroupClicked(templateGroup.id)">
        {{ templateGroup.title }}
      </span>
    }
  </div>
  <div class="templates" [class.single]="viewMode === 'single'">
    @for (preview of getTemplatePreviews(); track trackById($index, preview.template)) {
      <div
        class="template"
        [ngClass]="{'active': preview.template.id === selectedTemplateId}"
        (click)="updateSelectedTemplate(preview.template.id)"
        >
        <div class="preview-image" [ngStyle]="loadingImageStyle">
          <img [attr.src]="preview.previewUrl"
               loading="lazy"
               #templatePreviewImage
               (error)="onPreviewImageError(preview)" />
        </div>
        <div class="title">
          @if (preview.template.title !== '') {
            <span class="title-text">{{ preview.template.title }}</span>
          }
          @if (placeholdersCount(preview.template) > 0) {
            <span class="suitable-for">
              @if (preview.template.title !== '') {
                –
              }
              {{ 'i18n.toolbox.layout.template.suitableFor' | translate:placeholdersCount(preview.template) }}
            </span>
          }
        </div>
        <div class="in-use-message">
          @if (preview.template.id === selectedTemplateId) {
            {{ 'i18n.toolbox.layout.template.inUse' | translate }}
          }
        </div>
      </div>
    }
  </div>
}
